module.exports = __webpack_public_path__ + "static/media/anestesia.b8cf816d.png";